import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENV ?? "development",
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0,
});

import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";

import "./design-system/colors_and_type.css";
import App from "./App";
import ggTheme from "./theme/theme";
import { ggColorModeManager } from "./theme/colorModeManager";
import { PermissionsProvider } from "./data/permissions/permissionContext";
import { DownloadManagerProvider } from "./contexts/DownloadManagerContext";
import { AppErrorFallback } from "./components/AppErrorFallback";

import bearWavingImg from "./assets/Rindo acenando corpo inteiro.webp";
import bearPeekingImg from "./assets/Piscando sorriso rindo.webp";
import bearHelpImg from "./assets/bear-help.webp";
import onflyLogoImg from "./assets/onfly-logo.webp";

const CRITICAL_IMAGES = [bearWavingImg, bearPeekingImg, bearHelpImg, onflyLogoImg];

function preloadImages(images: string[], timeoutMs = 1500): Promise<void> {
  return Promise.race([
    Promise.all(
      images.map(
        (src) =>
          new Promise<void>((resolve) => {
            if (src.startsWith("data:")) return resolve();
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => resolve();
            img.src = src;
          })
      )
    ).then(() => {}),
    new Promise<void>((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
}

preloadImages(CRITICAL_IMAGES).finally(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ChakraProvider theme={ggTheme} colorModeManager={ggColorModeManager}>
        <PermissionsProvider>
          <DownloadManagerProvider>
            <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
              <App />
            </Sentry.ErrorBoundary>
          </DownloadManagerProvider>
        </PermissionsProvider>
      </ChakraProvider>
    </StrictMode>
  );
});
